// src/admin/controllers/GolferAdminController.js
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from '../../scoring/store/MetaStore'
import { useAdminStore } from '../store/AdminStore'
import GolferAdminView from '../views/GolferAdminView'

function GolferAdminController() {
  const [searchParams] = useSearchParams()
  const golferId = searchParams.get('golferId')
  const orgId = useAdminStore((state) => state.orgId)
  const orgName = useAdminStore((state) => state.orgName)

  const [golferData, setGolferData] = useState({
    golferName: '',
    email: '',
    competitor: false,
    inactive: false,
    fromDb: false,
    inactive: false,
    fromDb: false,
  })
  const setGlobalModal = useMetaStore((state) => state.setGlobalModal)
  const navigate = useNavigate()

  useEffect(() => {
    // Fetch golfer data from the API when the component mounts
    if (golferId) {
      apiClient.get(`/gskapi/golfers/find/${golferId}`)
        .then((response) => {
          setGolferData(response.data)
        })
        .catch((error) => {
          console.error('Error fetching golfer data:', error)
        })
    }
  }, [golferId])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    if (type === 'checkbox') {
      setGolferData({ ...golferData, [name]: checked })
    } else {
      setGolferData({ ...golferData, [name]: value })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const payload = {
      ...golferData,
      orgId: orgId,
    }

    try {
      const res = await apiClient.post('/gskapi/golfers/save', payload)
      if (res.status === 200 || res.status === 201) {
        setGlobalModal(true, 'Save Successful', '#060')
        navigate('/admin/golfers')
      } else {
        setGlobalModal(true, 'Failed to save golfer data.', '#900')
      }
    } catch (error) {
      console.error('Error saving golfer data:', error)
      setGlobalModal(true, 'Error saving golfer data.', '#900')
    }
  }

  const handleCancel = () => {
    navigate('/admin/golfers')
  }

  const handleDelete = () => {
    apiClient
      .post(`/gskapi/golfers/delete`, { golferId: golferId })
      .then((res) => {
        if (res.status === 200) {
          navigate('/admin/golfers')
        } else {
          console.error(`Error deleting golfer: status ${res.status}`)
        }
      })
  }

  return (
    <GolferAdminView
      golferData={golferData}
      orgName={orgName}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      handleDelete={handleDelete}
    />
  )
}

export default GolferAdminController
